import httpMethod from 'services/update2025/httpMethod';
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { listSuggestion } from "services/VNeIDJobService";

const VNeIDJobSuggestion = (props) => {
    //! define
    const { setOpenModalSuggestion, server, valueForm, setValueForm } = props;
    const toast = useRef(null);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    const { t, i18n } = useTranslation(["vneid-job", "config", "common"]);
    //! state
    const [titleEditor] = useState(t("vneid-job.titleSuggestionDetail"));
    const [dataSuggestion, setDataSuggestion] = useState();

    //! function
    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const getListSuggest = () => {
        listSuggestion(headers, server)
            .then((res) => {
                if (res.status === 200) {
                    const list = res.data.map((el) => {
                        return {
                            name: el,
                        };
                    });
                    setDataSuggestion(list);
                }
            })
            .catch((e) => { })
            .finally(() => { });
    };

    const actionBodyVNeID = (rowData) => {
        return (
            <div className="text-center">
                <Button
                    onClick={() => {
                        setValueForm({ ...valueForm, cronExpression: rowData.name });
                        setOpenModalSuggestion(false);
                    }}
                >
                    Chọn
                </Button>
            </div>
        );
    };

    //! useEffect
    useEffect(() => {
        if (server) {
            getListSuggest();
        }
    }, [server]);

    //! render
    return (
        <>
            <Toast ref={toast} />
            <Dialog
                visible={true}
                style={{ width: "20%" }}
                header={titleEditor.toUpperCase()}
                modal
                className="p-fluid text-center"
                onHide={() => {
                    setOpenModalSuggestion(false);
                }}
            >
                <DataTable value={dataSuggestion}>
                    <Column field="name" header={"Lịch chạy"} />
                    <Column body={actionBodyVNeID} />
                </DataTable>
            </Dialog>
        </>
    );
};

export default VNeIDJobSuggestion;
